import { useCallback, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AnnouncementBanner } from "./AnnouncementBanner";
import { MaintenancePage } from "./MaintenancePage";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

const ADMIN_ROLES = ["admin", "super_admin"];

export const Layout = () => {
  const [bannerVisible, setBannerVisible] = useState(false);
  const handleVisibilityChange = useCallback((visible) => setBannerVisible(visible), []);
  const location = useLocation();
  const { user } = useAuth();
  const { settings } = useSettings();
  const isMaintenance = settings.maintenance_mode && user !== null && !ADMIN_ROLES.includes(user?.role) && location.pathname !== "/login";

  return (
    <div className="min-h-screen bg-clean-white text-midnight-black flex flex-col">
      <AnnouncementBanner onVisibilityChange={handleVisibilityChange} />
      <Header bannerVisible={bannerVisible} />
      <main className={`flex-1 transition-[padding] duration-200 ${bannerVisible ? "pt-[124px]" : "pt-20"}`}>
        {isMaintenance ? <MaintenancePage /> : <Outlet />}
      </main>
      <Footer />
    </div>
  );
};
